import { Pipe, PipeTransform } from '@angular/core';

import { formatInlineAddress } from '../util/address-transformation.utils';

export enum AddressTransformationType {
  CLIENT_SHIPPING = 'clientShipping',
  ADDRESS = 'address',
  // Add more transformation types as needed
}

@Pipe({
  name: 'addressTransformation',
  standalone: true,
})
export class AddressTransformationPipe implements PipeTransform {
  transform(address :any, transformType :string) :string | null {
    switch (transformType) {
      case AddressTransformationType.ADDRESS:
        return formatInlineAddress.fromAddress(address);
      case AddressTransformationType.CLIENT_SHIPPING:
        return formatInlineAddress.fromClientShipping(address);
      // Add more transformation cases as needed
      default:
        return null; // Return null if no valid transformType is provided
    }
  }
}
